import { format, isValid, startOfDay } from "date-fns";
const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
export const parseDateOnly = (value) => {
    if (!value)
        return undefined;
    const trimmed = value.trim();
    if (!trimmed)
        return undefined;
    const match = DATE_ONLY_PATTERN.exec(trimmed);
    if (match) {
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const parsed = new Date(year, month - 1, day);
        if (parsed.getFullYear() === year &&
            parsed.getMonth() === month - 1 &&
            parsed.getDate() === day) {
            return parsed;
        }
        return undefined;
    }
    const parsed = new Date(trimmed);
    return isValid(parsed) ? parsed : undefined;
};
export const formatDateOnly = (value) => {
    if (!value || !isValid(value))
        return "";
    return format(value, "yyyy-MM-dd");
};
export const getTodayDateOnly = () => formatDateOnly(new Date());
export const isBeforeDateOnly = (candidate, minimum) => {
    if (!minimum || !isValid(candidate) || !isValid(minimum)) {
        return false;
    }
    return startOfDay(candidate) < startOfDay(minimum);
};
//# sourceMappingURL=date.js.map